import { Meal } from "@/clients/models/Meal";
import { MealTime } from "@/clients/models/MealTime";
import { BaseModal } from "@/components/modal/base-modal";
import { FilledButton } from "@/components/ui/buttons";
import { useViewportHeight } from "@/hooks/utils/use-viewport-height";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";
import { LikedFoodsOption } from "./liked-foods-option";
import { YourPlanOption } from "./your-plan-option";

interface AddMealToModalProps {
  isOpen: boolean;
  onDismiss: () => void;
  meal: Meal;
  mealTime: MealTime | undefined;
  notLikeable?: boolean;
}

export const AddMealToModal = memo(function AddMealToModal({
  isOpen,
  onDismiss,
  meal,
  mealTime,
  notLikeable,
}: AddMealToModalProps) {
  const viewportHeight = useViewportHeight();
  const defaultHeight = notLikeable ? 240 : 280;
  const initialBreakpoint = defaultHeight / viewportHeight;

  return (
    <BaseModal
      isOpen={isOpen}
      onDismiss={onDismiss}
      backdropDismiss={true}
      initialBreakpoint={initialBreakpoint}
      breakpoints={[0, initialBreakpoint]}
    >
      <div className="safe-area-bottom flex flex-col gap-3 px-8 pt-8 pb-8">
        <h2 className={cn(textVariants.title3, "h-8.5 text-center")}>Add meal to...</h2>

        <div className="flex flex-col gap-2">
          <YourPlanOption meal={meal} onComplete={onDismiss} />

          {!notLikeable && (
            <LikedFoodsOption meal={meal} mealTime={mealTime} onComplete={onDismiss} />
          )}

          <FilledButton color="gray" onClick={onDismiss}>
            Cancel
          </FilledButton>
        </div>
      </div>
    </BaseModal>
  );
});
